module.exports = __webpack_public_path__ + "img/pic_special4.f95e0837.png";